import React from 'react';
import { FaStar } from 'react-icons/fa6';
import { formatDateToLocal } from '../../utils/funtions';
import { API_BASE_URL } from '../../store/constans';

const RecomendationCards = ({ recomendationState }) => {

    return (
        <div className='flex justify-center gap-7 mx-2'>
            <div className="bg-gradient-to-b from-[#051937] to-[#008793] p-5 h-[460px] w-full rounded-md">
                <div className='bg-[#e0deda] h-full p-5 flex flex-col justify-between'>
                    <div className='flex w-full items-center gap-3 mb-5'>
                        <img  loading="lazy" className="rounded-full w-14 h-14 object-cover" src={`${API_BASE_URL}${recomendationState.image}`} alt={`${recomendationState.image}`} />
                        <div className='text-start'>
                            <h1 className='text-sky-900 font-bold'>{recomendationState.autor}</h1>
                            <div className='flex gap-2 items-center'>
                                {Array.from({ length: recomendationState.calification }, (_, index) => (
                                    <FaStar key={index} color='orange' />
                                ))}
                                <p>{formatDateToLocal(recomendationState.createdAt)}</p>
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between w-full items-center gap-3'>
                        <div className='text-start'>
                            <h1 className='text-sky-900 font-bold'>{recomendationState.title}</h1>
                            <div className='flex gap-2 items-center font-sans text-gray-800 mb-5'>
                                <p>{recomendationState.description}</p>
                            </div>
                        </div>
                    </div>
                    <div className='flex text-start flex-col font-sans text-gray-800'>
                        <p>Posted in</p>
                        <p className='text-sky-900 font-bold'>{recomendationState.posted}</p>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default RecomendationCards;